import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const instrumentationsModule = {
  namespaced: true,
  state() {
    return {
      instrumentations: [],
      instrumentationsTask: [],
      instrumentationHistory: [],
      instrumentationJobHistory: [],
      instrumentationCountsBySiteId: {},
    };
  },
  actions,
  getters,
  mutations,
};

export default instrumentationsModule;
